const svgIcon = (paths) =>
  `<svg class="evt-svg-icon" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

export const CAKE_SVG = svgIcon(
  '<path d="M4 21v-7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7"></path>' +
    '<path d="M2 21h20"></path>' +
    '<path d="M7 12v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"></path>' +
    '<path d="M12 8V5.5"></path>' +
    '<path d="M12 5c-.8 0-1.5-.7-1.5-1.5S11.2 2 12 2s1.5.7 1.5 1.5S12.8 5 12 5z"></path>'
);

export const SKULL_SVG = svgIcon(
  '<path d="M12 2a7 7 0 0 0-7 7c0 3 1.5 4.5 2 6v3a1 1 0 0 0 1 1h1.5l.5-1.5h4l.5 1.5H16a1 1 0 0 0 1-1v-3c.5-1.5 2-3 2-6a7 7 0 0 0-7-7z"></path>' +
    '<circle cx="9.5" cy="10" r="1.3"></circle>' +
    '<circle cx="14.5" cy="10" r="1.3"></circle>' +
    '<path d="M11 14h2"></path>'
);

export const CANDLE_SVG = svgIcon(
  '<path d="M12 2c1 1.5 1.8 2.6 1.8 3.6a1.8 1.8 0 1 1-3.6 0C10.2 4.6 11 3.5 12 2z"></path>' +
    '<line x1="12" y1="7.5" x2="12" y2="10"></line>' +
    '<rect x="9" y="10" width="6" height="11" rx="1"></rect>' +
    '<line x1="9" y1="14" x2="15" y2="14"></line>'
);

export const QUILL_SVG = svgIcon(
  '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>' +
    '<line x1="16" y1="8" x2="2" y2="22"></line>' +
    '<line x1="17.5" y1="15" x2="9" y2="15"></line>'
);

export const HOURGLASS_SVG = svgIcon(
  '<path d="M5 22h14"></path>' +
    '<path d="M5 2h14"></path>' +
    '<path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"></path>' +
    '<path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"></path>'
);

export const LEVEL_UP_SVG = svgIcon('<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>');

export const NEW_MOON_SVG = svgIcon('<circle cx="12" cy="12" r="8"></circle>');

export const FULL_MOON_SVG = svgIcon('<circle cx="12" cy="12" r="8" fill="currentColor"></circle>');

export const FIRST_QUARTER_MOON_SVG = svgIcon(
  '<circle cx="12" cy="12" r="8"></circle>' + '<path d="M12 4 A8 8 0 0 1 12 20 Z" fill="currentColor"></path>'
);

export const LAST_QUARTER_MOON_SVG = svgIcon(
  '<circle cx="12" cy="12" r="8"></circle>' + '<path d="M12 4 A8 8 0 0 0 12 20 Z" fill="currentColor"></path>'
);
